module.exports = __webpack_public_path__ + "static/contests-mail-log-807b873fcf326cb3f49c433e0100b9a1.png";